export function CheckIcon({ className, style, strokeWidth = 3 }) {
	return (
		<svg className={className} style={style} viewBox="0 0 24 24" aria-hidden="true">
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M4 12l5 5L20 7"
			/>
		</svg>
	);
}

export function ExclamationIcon({ className, style, strokeWidth = 3 }) {
	return (
	  <svg className={className} style={style} viewBox="0 0 24 24" aria-hidden="true">
			<path
				fill="currentColor"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="m9.64921,1.5l2.35079,12.29166l2.35079,-12.29166l-4.70158,0z"
			/>
			<ellipse
				fill="currentColor"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				ry="1.08108"
				rx="1.14865"
				id="svg_2"
				cy="21.41892"
				cx="12"
			/>
		</svg>
	);
}

export function PowerIcon({ className, style, strokeWidth = 3 }) {
	return (
		<svg className={className} style={style} viewBox="0 0 24 24" aria-hidden="true">
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M18.36 6.64a9 9 0 1 1-12.73 0M12 2v10"
			/>
		</svg>
	);
}

export function PlusIcon({ className, style, strokeWidth = 3 }) {
	return (
		<svg className={className} style={style} viewBox="0 0 24 24" aria-hidden="true">
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M12 5v14M5 12h14"
			/>
		</svg>
	);
}

export function FlameIcon({ className, style }) {
	return (
		<svg className={className} style={style} viewBox="0 0 24 24" aria-hidden="true">
			<path
				className="streak-flame__outer"
				d="M12 1 C12.5 4 8.5 5.5 8 9 C7.5 12 9.5 14 12 22 C14.5 14 16.5 12 16 9 C15.5 5.5 11.5 4 12 1 Z"
				fill="currentColor"
			/>
			<path
				className="streak-flame__core"
				d="M12 8 C11.5 11.5 14 12.5 12 17 C10 12.5 12.5 11.5 12 8 Z"
				fill="currentColor"
			/>
		</svg>
	);
}
